import React from 'react'
import img from '../assets/l.jpg'
import Service from './Service'
import { DiJavascript } from 'react-icons/di'
import { SiTailwindcss } from 'react-icons/si'
import { DiReact } from 'react-icons/di'
import { DiBootstrap} from 'react-icons/di' 
import { DiGit } from 'react-icons/di'
import { DiGithub } from 'react-icons/di'
import {FaQuran} from 'react-icons/fa'
import {FaBook} from 'react-icons/fa'
import {SiYourtraveldottv} from 'react-icons/si'
import {IoIosFootball, IoLogoGameControllerB} from 'react-icons/io'
import {motion} from 'framer-motion'




function About() {
  return (
    <>
    <motion.div className='grid grid-cols-1 md:grid-cols-2  items-center   '
    
    initial={{x:-100 }}
    animate={{x:0}} >
     
      {/* left  */}
      <div className='flex items-center ml-20 p-4'> 

        <div className=' rounded-md  mt-20 i  '>
            <img src={img} className="p-1    rounded-3xl h-3/4 w-3/4  shadow-2xl hover:-translate-y-3 duration-1000  " alt="khader" />
      </div>
      </div>
      
      {/* right  */}
        <div div className=' mt-8 '
        initial={{x:100}}
        animate={{x:0}}>
                <h1 className=' text-gray-500 text-3xl text-center font-serif'>
                    About Me
                </h1>
                <p  className=' text-gray-600 mt-8 text-base font-serif'>
                    “I'm a web developer with a focus on the MERN stack, but still exploring  other technologies and
                    frameworks that catch my interest! if you're looking for a developer to add to your team, I'd love to hear from you!.”</p>
            

                            {/* tools */}

            <div className='mt-5'>
                <h1 className='text-gray-500 text-lg font-semibold font-mono'> Tools </h1>
                <br />
                <div className='flex flex-wrap items-center w-full space-x-5  text-xl'>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiJavascript className='text-yellow-500 text-xl'/> Javascript
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiJavascript className='text-orange-600 text-xl'/> html
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiJavascript className='text-blue-700 text-xl'/> data sciencc
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <SiTailwindcss className='text-blue-700 text-xl'/> Tailwindcss
                    </div>
                     
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiReact className='text-blue-700 text-xl'/> React
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiBootstrap className='text-purple-600 text-xl'/> Bootstrap
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiGit className='text-red-600 text-xl'/> Git 
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiGithub className='text-dark-600 text-xl'/> Github 
                    </div>
                    
                

                </div>
            
            </div>

                    {/* interest */}
            <div className='mt-10'>
                <h1 className='text-gray-500 text-lg font-semibold font-mono'> My intarest </h1>
                <br />
                <div className='flex flex-wrap items-center w-full space-x-5 text-xl'>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <FaQuran className='text-green-400 text-xl'/>  Quran
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <SiYourtraveldottv className='text-blue-700 text-xl'/> Travel
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <FaBook className=' text-xl'/> Books
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <IoIosFootball className=' text-xl'/> Football
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <IoLogoGameControllerB className='text-black text-xl'/> Gaming
                    </div>
                    
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiBootstrap className='text-purple-600 text-xl'/> Bootstrap
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiGit className='text-red-600 text-xl'/> Git 
                    </div>
                    <div className='flex flex-wrap bg-white shadow-inner  text-sm rounded-lg p-2 font-medium '>
                        <DiGithub className='text-dark-600 text-xl'/> Github 
                    </div>
                    
                

                </div>
                
            </div>
        </div>
       
       
     </motion.div>
 <Service/>

     </>
  );
}

export default About
